import { graphql, useFragment } from 'react-relay';
import { useNoSurveysFragmentQuery_noSurveysRef$key } from './__generated__/useNoSurveysFragmentQuery_noSurveysRef.graphql';
const fragment = graphql`
  fragment useNoSurveysFragmentQuery_noSurveysRef on Query {
    endlessProfilerUrl
    profilerUrl
    userData {
      firstName
    }
    notificationSubscriptions {
      ...PushNotificationsCardFragment_notificationSubscriptions
    }
  }
`;

export function useNoSurveysFragmentQuery(
  noSurveysRef: useNoSurveysFragmentQuery_noSurveysRef$key,
) {
  return useFragment<useNoSurveysFragmentQuery_noSurveysRef$key>(fragment, noSurveysRef);
}
